// extracted by mini-css-extract-plugin
export default {"cvError":"B5-z"};